import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-702bd6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card ss-fadein" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ss-div-icone-etapa" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-icone-etapa",
    img: "",
    src: "/static/img/configuracao-inicial/icone-equipe.png"
  })
], -1))
const _hoisted_4 = { class: "ant-col ss-div-conteudo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-card" }, "Monte sua equipe", -1))
const _hoisted_6 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Crie novos usuários,  ", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Cadastre as funções dos seus colaboradores,   ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Cadastre seus colaboradores,   ", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-subtitulo-card" }, "Cadastre seus departamentos", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ant-col ss-div-icone-etapa" }
const _hoisted_16 = {
  key: 0,
  class: "ss-icone-etapa ss-fadein",
  img: "",
  src: "/static/img/configuracao-inicial/icone-feito.png"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_usuario_modal = _resolveComponent("usuario-modal")!
  const _component_departamento_modal = _resolveComponent("departamento-modal")!
  const _component_funcao_modal = _resolveComponent("funcao-modal")!
  const _component_pessoa_modal = _resolveComponent("pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.computedConfiguracao.etapaAtual === _ctx.EEtapaConfiguracaoInicial.Equipe)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.state.permisaoUsuario)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirUsuario && _ctx.abrirUsuario(...args)))
                  }, _hoisted_8))
                : _createCommentVNode("", true),
              (_ctx.state.permissaoFuncao)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirFuncao && _ctx.abrirFuncao(...args)))
                  }, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.state.permissaoColaborador)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.abrirColaboradores && _ctx.abrirColaboradores(...args)))
                  }, _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.state.permissaoDepartamento)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.abrirDepartamentos && _ctx.abrirDepartamentos(...args)))
                  }, _hoisted_14))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.computedConfiguracao.etapaAtual !== _ctx.EEtapaConfiguracaoInicial.Equipe)
          ? (_openBlock(), _createElementBlock("img", _hoisted_16))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ss-botao-concluir",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.concluir && _ctx.concluir(...args)))
            }, [
              _createVNode(_component_a_spin, {
                spinning: _ctx.state.carregando
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Concluir!")
                ]),
                _: 1
              }, 8, ["spinning"])
            ]))
      ])
    ]),
    _createVNode(_component_usuario_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirUsuario,
      "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.exibirUsuario) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_departamento_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirDepartamento,
      "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.exibirDepartamento) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_funcao_modal, {
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirFuncao,
      "onUpdate:visivel": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.exibirFuncao) = $event))
    }, null, 8, ["operacao", "visivel"]),
    _createVNode(_component_pessoa_modal, {
      relacaoPrincipalOperacao: _ctx.ETipoRelacaoPessoa.Colaborador,
      tituloModal: "Cadastro de Colaborador",
      servicoAPI: _ctx.servicoColaborador,
      operacao: _ctx.state.operacao,
      visivel: _ctx.state.exibirColaborador,
      "onUpdate:visivel": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.exibirColaborador) = $event))
    }, null, 8, ["relacaoPrincipalOperacao", "servicoAPI", "operacao", "visivel"])
  ]))
}